export default __webpack_public_path__ + "static/media/lingon_logo.c8f1630d.png";